export class TeacherModel{
  name:string = 'xxx xxx xxx';
  imgUrl:string = 'xxxxxxx.xxx';
  teacherId:string = 'xxxxxxxxxxxx';
}
